/**
 * Registers the slice's translations into the shared "financialAids" namespace.
 *
 * Feature slices add their own keys with addResourceBundle rather than editing
 * the shared locale JSON (see lib/i18n/i18n.ts). Importing this module for its
 * side effect (from index.tsx / the action-plan cell) is enough.
 */
import i18n from "@/lib/i18n/i18n";

import { financialAidsEn } from "./locales/en";
import { financialAidsFr } from "./locales/fr";

i18n.addResourceBundle(
  "fr",
  "translation",
  { financialAids: financialAidsFr },
  true,
  true,
);
i18n.addResourceBundle(
  "en",
  "translation",
  { financialAids: financialAidsEn },
  true,
  true,
);
